import { render, staticRenderFns } from "./VariationProperties.vue?vue&type=template&id=81983d88&"
import script from "./VariationProperties.vue?vue&type=script&lang=js&"
export * from "./VariationProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JVolke\\Documents\\plentyDevTool\\38722\\18\\KrauseSohn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81983d88')) {
      api.createRecord('81983d88', component.options)
    } else {
      api.reload('81983d88', component.options)
    }
    module.hot.accept("./VariationProperties.vue?vue&type=template&id=81983d88&", function () {
      api.rerender('81983d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/VariationProperties.vue"
export default component.exports